import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './meeting-archives.types';
import * as constants from './meeting-archives.constants';

export const storeMeetingArchive = generateStoreResourceAction<types.IMeetingArchive>(constants.STORE_MEETING_ARCHIVE);
export const clearMeetingArchive = generateClearResourceAction(constants.CLEAR_MEETING_ARCHIVE);
